import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { ANALYTICS_TIMEFRAME } from '../../../Reports/types';

import './TimelineTag.styles.scss';

const TIMEFRAME_COPY = {
  [ANALYTICS_TIMEFRAME.SEVEN_DAYS]: '7D',
  [ANALYTICS_TIMEFRAME.OVERALL]: 'overall',
};

type TimelineTagProps = {
  className?: string;
};

const TimelineTag: React.FC<TimelineTagProps> = (props) => {
  const { className } = props;

  const { preferredAnalyticsTimeframe } = useContext(DataRoomContext);

  const classes = classNames('timeline-tag', className);

  const { t } = useTranslation();

  return (
    <p className={classes}>{t(TIMEFRAME_COPY[preferredAnalyticsTimeframe])}</p>
  );
};

export default TimelineTag;
